import orderBy from 'lodash/orderBy';
import remove from 'lodash/remove';

/**
 * The callback are executed in order of priority.
 * The priority with the lowest number will be executed first
 */
export class ContainerClosable {
    private closeCallbacks: Array<{ priority: number; callback: () => Promise<void> }> =
        [];

    registerCloseCallback = (
        priority: number,
        callback: () => Promise<void>,
    ): (() => void) => {
        this.closeCallbacks.push({ priority, callback });

        return () => {
            remove(this.closeCallbacks, (item) => {
                return item.priority === priority && item.callback === callback;
            });
        };
    };

    async close(this: this) {
        try {
            const callbacks = orderBy(this.closeCallbacks, ({ priority }) => priority, [
                'asc',
            ]).map(({ callback }) => callback);

            this.closeCallbacks = [];

            for (const callback of callbacks) {
                await callback();
            }

            return;
        } catch {
            return;
        }
    }
}
